import React from 'react';
import Title from 'components/typografy/title';
import Text from 'components/typografy/text';
import StyledButton from 'components/styled-button';
import { DialogCloseTrigger, DialogRoot, DialogTrigger } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import Dialog from '../dialog';
import { AlertTypes } from '../../enums/api';
import styles from './styles.module.scss';

interface LogoutModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  onLogout: () => void;
  isLoading: boolean;
  triggerElement: React.ReactNode;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
                                                   isOpen,
                                                   onOpenChange,
                                                   onLogout,
                                                   isLoading,
                                                   triggerElement
                                                 }) => {
  return (
    <DialogRoot
      scrollBehavior="inside"
      size="sm"
      onOpenChange={onOpenChange}
      onCloseChange={onOpenChange}
      placement="center"
    >
      <DialogTrigger>
        {triggerElement}
      </DialogTrigger>
      <Dialog isOpen={isOpen} contentClassNames={styles.dialog}>
        <Title variant={'h1'} nativeClassNames={styles.title}>
          Logout
        </Title>
        <Text variant={'medium'}>Are you sure you want to log out of your account?</Text>
        <div className={styles.row}>
          <DialogCloseTrigger>
            <StyledButton isLoading={false} variant={AlertTypes.ERROR}>
              Cancel
            </StyledButton>
          </DialogCloseTrigger>
          <Button variant={'ghost'} onClick={onLogout} disabled={isLoading}>
            <StyledButton isLoading={isLoading}>Logout</StyledButton>
          </Button>
        </div>
      </Dialog>
    </DialogRoot>
  );
};

export default LogoutModal;